function More({ text = 'MORE' }) {
	return {
		$template: '#template-more',
		text,
		mounted(el) { }
	}
}

function linkBtn(props) {
	return {
		$template: '#template-linkBtn',
		title: props.title || 'MORE',
		link: props.link || 'javascript:void(0)',
		addClass: props.addClass || 'vw-text-[19]',
		newWeb: props.newWeb || '_self',
	}
}

function functionBtn(props) {
	return {
		$template: '#template-functionBtn',
		title: props.title || 'MORE',
		// fn: props.fn || '',
		addClass: props.addClass || 'vw-text-[19]',
	}
}

function pagination(props) {
	return {
		$template: '#template-pagination',
		total: props.total || 1,
		current: props.current || 1,
		baselink: props.baselink || '',

		get pages() {
			const t = parseInt(this.total);
			const c = parseInt(this.current);
			const range = 1;

			// 情況 0: 總頁數 <= 7，顯示全部
			if (t <= 7) {
				// 產生 [1, 2, 3, ... t] 的陣列
				return Array.from({ length: t }, (_, i) => i + 1);
			}

			// 情況 1: 目前頁面在前段 (<= 3) -> 顯示 1~5 ... 最後一頁
			if (c <= 3) {
				return [1, 2, 3, 4, 5, '...', t];
			}

			// 情況 2: 目前頁面在後段 (>= 總頁數-2) -> 顯示 1 ... 最後5頁
			else if (c >= t - 2) {
				const last5 = Array.from({ length: 5 }, (_, i) => t - 4 + i); // [t-4, t-3, t-2, t-1, t]
				return [1, '...', ...last5];
			}

			// 情況 3: 中間狀態 -> 1 ... 前1 當前 後1 ... 最後一頁
			else {
				return [1, '...', c - 1, c, c + 1, '...', t];
			}
		},

		mounted(el) {
			// 如果需要除錯，可以在這裡 console.log(this.pages)
		}
	}
}


export {
	More, linkBtn,functionBtn, pagination
}
